import { Accordion, Container } from 'react-bootstrap';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkuEnum } from '@/types/translations/SkuEnum';

// FAQ Section with enhanced interactivity

export const FAQSection: React.FC<{
  faqs?: Record<string, { question: string; answer: string }> | null;
}> = ({ faqs }) => {
  const { translate: translateSku } = useTypedTranslation<SkuEnum>('sku');

  if (!faqs || Object.keys(faqs).length === 0) return null;

  return (
    <div className={`faqsection tw-mt-[60px] tw-bg-customGray tw-py-[60px]`}>
      <Container>
        <div className="tw-align-items-center tw-mb-[40px] tw-flex tw-justify-between max-sm:tw-flex-col max-sm:tw-text-center">
          <h2>
            {translateSku(SkuEnum.do_you_have_any_questions)} <br />
          </h2>
          <PrimaryButtonLink
            href={'mailto:help@spiritory.com'}
            className="d-flex font-weight-bold justify-content-center tw-px-[60px] max-sm:tw-m-auto max-sm:tw-mt-[15px]"
          >
            {translateSku(SkuEnum.contact_us)}
          </PrimaryButtonLink>
        </div>

        <Accordion>
          {Object.entries(faqs).map(([key, item], index) => (
            <Accordion.Item eventKey={`${index}`} key={key}>
              <Accordion.Header>
                {item.question} {/* Zugriff auf die `question`-Eigenschaft */}
              </Accordion.Header>

              <Accordion.Body>
                {item.answer} {/* Zugriff auf die `answer`-Eigenschaft */}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </div>
  );
};
